export const IconEnterprise = ({ color, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 31 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6264 4.4375H6.62257C4.06597 4.4375 2.78125 5.73507 2.78125 8.31736V28.8472H9.71875V24.0295C9.71875 23.5028 10.1556 23.066 10.6823 23.066C11.209 23.066 11.6458 23.4899 11.6458 24.0295V28.8472H18.4549V8.31736C18.4549 5.73507 17.183 4.4375 14.6264 4.4375ZM13.8941 16.9635H7.53472C7.00799 16.9635 6.57118 16.5267 6.57118 16C6.57118 15.4733 7.00799 15.0365 7.53472 15.0365H13.8941C14.4208 15.0365 14.8576 15.4733 14.8576 16C14.8576 16.5267 14.4208 16.9635 13.8941 16.9635ZM13.8941 12.1458H7.53472C7.00799 12.1458 6.57118 11.709 6.57118 11.1823C6.57118 10.6556 7.00799 10.2187 7.53472 10.2187H13.8941C14.4208 10.2187 14.8576 10.6556 14.8576 11.1823C14.8576 11.709 14.4208 12.1458 13.8941 12.1458Z"
        fill={color}
      />
      <path
        d="M29.6298 27.8875H26.7135V24.0333C27.9339 23.6351 28.8204 22.4917 28.8204 21.1427V18.5733C28.8204 16.8903 27.4457 15.5156 25.7628 15.5156C24.0798 15.5156 22.7051 16.8903 22.7051 18.5733V21.1427C22.7051 22.4788 23.5787 23.6094 24.7735 24.0205V27.8875H1.36589C0.839149 27.8875 0.402344 28.3243 0.402344 28.851C0.402344 29.3778 0.839149 29.8146 1.36589 29.8146H25.6857C25.7114 29.8146 25.7242 29.8274 25.7499 29.8274C25.7756 29.8274 25.7885 29.8146 25.8141 29.8146H29.6298C30.1565 29.8146 30.5933 29.3778 30.5933 28.851C30.5933 28.3243 30.1565 27.8875 29.6298 27.8875Z"
        fill={color}
      />
    </svg>
  );
};
